import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConIdioma, tx } from './i18n';
import { createBrowserRouter, Navigate, Outlet, RouterProvider, useLocation } from 'react-router';
import { ErrorDeApi } from './lib/api';
import { Marco } from './marco/Marco';
import { Appliance } from './paginas/Appliance';
import { Appliances } from './paginas/Appliances';
import { Red } from './paginas/Red';
import { RedDeCliente } from './paginas/RedDeCliente';
import { Consola } from './paginas/Consola';
import { Ingreso, NuevaClave } from './paginas/Ingreso';
import { NoExiste } from './paginas/NoExiste';
import { Ajustes } from './paginas/Ajustes';
import { Tablero } from './paginas/Tablero';
import { SesionProvider, useSesion } from './sesion/sesion';
import { Logo } from './ui/Logo';

export function crearQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // El Centro no tiene tiempo real: lo que se ve se refresca solo cada tanto.
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        // Un 4xx no mejora reintentando; un corte de red sí.
        retry: (n, e) => !(e instanceof ErrorDeApi && e.codigo >= 400 && e.codigo < 500) && n < 2,
      },
    },
  });
}

function Raiz() {
  return (
    <SesionProvider>
      <Outlet />
    </SesionProvider>
  );
}

/** Pide sesión: sin ella, al ingreso, y después de entrar se vuelve adonde quería ir. */
function ConSesion() {
  const { usuario, cargando } = useSesion();
  const donde = useLocation();
  if (cargando)
    return (
      <div className="cargando-app" role="status">
        <Logo />
        <span>{tx.comun.abriendo}</span>
      </div>
    );
  if (!usuario) return <Navigate to={`/ingresar?volver=${encodeURIComponent(donde.pathname + donde.search)}`} replace />;
  return <Marco />;
}

export const rutas = [
  {
    element: <Raiz />,
    children: [
      { path: '/ingresar', element: <Ingreso /> },
      { path: '/clave', element: <NuevaClave /> },
      {
        element: <ConSesion />,
        children: [
          { index: true, element: <Tablero /> },
          { path: 'red', element: <Red /> },
          { path: 'appliances', element: <Appliances /> },
          { path: 'appliances/:id', element: <Appliance /> },
          { path: 'appliances/:id/red', element: <RedDeCliente /> },
          { path: 'appliances/:id/consola', element: <Consola /> },
          // Organizaciones, Versiones, Bitácora y Usuarios viven en Ajustes: las direcciones viejas llevan ahí
          { path: 'organizaciones', element: <Navigate to="/ajustes/organizaciones" replace /> },
          { path: 'versiones', element: <Navigate to="/ajustes/versiones" replace /> },
          { path: 'bitacora', element: <Navigate to="/ajustes/bitacora" replace /> },
          { path: 'usuarios', element: <Navigate to="/ajustes/usuarios" replace /> },
          { path: 'ajustes', element: <Ajustes /> },
          { path: 'ajustes/:seccion', element: <Ajustes /> },
          { path: '*', element: <NoExiste /> },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(rutas);
const qc = crearQueryClient();

export function App() {
  return (
    <QueryClientProvider client={qc}>
      {/* al cambiar de idioma se vuelve a pintar todo, hasta lo que no usa hooks */}
      <ConIdioma>
        <RouterProvider router={router} />
      </ConIdioma>
    </QueryClientProvider>
  );
}
